import { HeadingNode } from '@lexical/rich-text';

export class HeadingAnchorNode extends HeadingNode {
  __anchorId;

  static getType() {
    return 'heading-anchor';
  }

  static clone(node) {
    return new HeadingAnchorNode(node.__tag, node.__anchorId, node.__key);
  }

  constructor(tag, anchorId, key) {
    super(tag, key);
    this.__anchorId = anchorId || '';
  }

  createDOM(config) {
    const dom = super.createDOM(config);
    if (this.__anchorId) {
      dom.setAttribute('id', this.__anchorId);
    }
    return dom;
  }

  updateDOM(prevNode, dom, config) {
    const didUpdate = super.updateDOM(prevNode, dom, config);
    if (prevNode.__anchorId !== this.__anchorId) {
      if (this.__anchorId) {
        dom.setAttribute('id', this.__anchorId);
      } else {
        dom.removeAttribute('id');
      }
    }
    return didUpdate;
  }

  setAnchorId(anchorId) {
    const writable = this.getWritable();
    writable.__anchorId = anchorId || '';
  }

  getAnchorId() {
    return this.getLatest().__anchorId;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'heading-anchor',
      anchorId: this.__anchorId,
      version: 1,
    };
  }

  static importJSON(serializedNode) {
    const node = $createHeadingAnchorNode(
      serializedNode.tag,
      serializedNode.anchorId
    );
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }
}

export function $createHeadingAnchorNode(tag, anchorId) {
  return new HeadingAnchorNode(tag, anchorId);
}

export function $isHeadingAnchorNode(node) {
  return node instanceof HeadingAnchorNode;
}
